/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Paragraph, Button } from '@verso/components';
import { navigate } from '@reach/router';
import ErrorContentTemplate from '../ErrorContentTemplate';
import PageSimpleTemplate from '../PageSimpleTemplate';

const AppError = ({ ...props }) => {
  return (
    <PageSimpleTemplate
      {...props}
      backgroundUrl="https://media.versoapp.com/Images/backgrounds/teacher-class.jpg"
    >
      <ErrorContentTemplate title="Whoops! It looks like something went wrong.">
        <Paragraph>
          An unexpected error has occured, please try reloading the page.
        </Paragraph>
        <Paragraph>
          <a
            href="https://support.versoapp.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'underline', color: 'textWhite' }}
          >
            get in touch
          </a>{' '}
          if we can be of assistance.
        </Paragraph>
        <Button
          variant="outlined"
          sx={{
            borderColor: 'textWhite',
            color: 'textWhite',
            bg: 'transparent',
          }}
          onClick={() => {
            navigate('/');
          }}
        >
          Go to dashboard
        </Button>
        <Button
          variant="text"
          sx={{
            color: 'textWhite',
            bg: 'transparent',
          }}
          onClick={() => {
            localStorage.clear();
            location.reload();
          }}
        >
          logout
        </Button>
      </ErrorContentTemplate>
    </PageSimpleTemplate>
  );
};

export default AppError;
